import { PublicImg as BasePublicImg } from '@airship-platform/jam-web/components';
import { ComponentProps } from 'react';
import { useAssetContext } from './AssetContext';

type BaseProps = ComponentProps<typeof BasePublicImg>;
type PublicImgProps = Omit<BaseProps, 'basePublicFilesUrl'> & {
  basePublicFilesUrl?: string;
};

const PublicImg: React.FC<PublicImgProps> = ({
  basePublicFilesUrl,
  ...props
}) => {
  const { basePublicFilesUrl: contextUrl } = useAssetContext();

  return (
    <BasePublicImg
      basePublicFilesUrl={basePublicFilesUrl || contextUrl}
      {...props}
    />
  );
};

export default PublicImg;
